module.exports = __webpack_public_path__ + "static/running_plans_mobile-b8924834c49d144b9c94b2cc9ce9ec96.jpg";